<template>
  <el-container class="body_container">
    <el-header style="height: 100px;padding:0px">
      <el-row class="body_title">分类</el-row>
      <el-row type="flex">
        <el-col>
          <el-form class="search_select" v-model="searchVo" :inline="true" size="small">
            <el-form-item style="margin: 0px">
              <el-input v-model="searchVo.name" placeholder="输入名字查询" style="width: 200px">
                <el-button slot="append" @click="search" icon="el-icon-search"></el-button>
              </el-input>
              <!--<el-input placeholder="请输入内容" v-model="searchVo.title" class="input-with-select">-->
              <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
              <!--</el-input>-->
            </el-form-item>
            <el-form-item class="dialog-footer" v-if="!xiaStatus">
              <el-button type="primary" @click="addType">添加分类</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-header>
    <!--视频分类列表-->
    <el-main class="search_result emp_search_result">
      <!--<div class="demo-image">-->
        <!--<div class="block" v-for="fit in typeList" :key="fit.id" style="display: inline-block;width: 19.39%;margin: 1px 3px">-->
          <!--<el-image-->
            <!--style="width: 100%; height: 150px"-->
            <!--:src="imgUrl + fit.image"-->
            <!--fit="contain">-->
            <!--<div slot="error" class="image-slot">-->
              <!--<img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1585824168269&di=d2d43b809b044a0c174ccb202677f266&imgtype=0&src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20180828%2F43bbc000b5ff4222b7e83aff69410805.jpeg" style="width: 100%; height: 100%">-->
            <!--</div>-->
          <!--</el-image>-->
          <!--<p class="demonstration" style="text-align:left;font-size:6px;">{{ fit.name }}</p>-->
          <!--<div class="bottom clearfix">-->
            <!--<el-link @click="updateType(fit.id)">修改</el-link>-->
            <!--<el-link @click="deleteType(fit.id)">删除</el-link>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!--<el-row v-for="fit in typeList" :key="fit.id" style="display: inline-block;width: 19.39%;margin: 1px 3px">-->
        <!--<el-col :span="2">-->
          <!--<i class="el-icon-folder-opened" style="font-size:25px"></i>-->
        <!--</el-col>-->
        <!--<el-col :span="5">-->
          <!--<p class="demonstration" style="text-align:left;font-size:6px;">{{ fit.name }}</p>-->
        <!--</el-col>-->
        <!--<el-col :span="5">-->
          <!--<time class="time">{{ fit.createdTime }}</time>-->
        <!--</el-col>-->
        <!--<el-col :span="5">-->
          <!--<el-link @click="updateType(fit.id)">修改</el-link>-->
          <!--<el-link @click="deleteType(fit.id)">删除</el-link>-->
        <!--</el-col>-->
      <!--</el-row>-->
      <span style="padding-left: 20px" v-if="!xiaStatus">全部文件</span>
      <span v-else>
        <el-link style="padding-left: 20px" @click="backTo" type="primary">返回上一级</el-link>
        {{'/'+ rowName}}
      </span>
      <!--<el-link style="padding-left: 20px" v-else @click="backTo" type="primary">返回上一级</el-link>-->
      <el-table :data="typeList.list">
        <el-table-column prop="id" width="40px">
          <template slot-scope="scope">
            <span v-if="!xiaStatus">
              <i class="el-icon-folder-opened" style="font-size:25px;color:#F5D558"></i>
            </span>
            <span v-else>
              <!--<img :src="imgUrl + scope.row.img"  min-width="70" height="70" />-->
              <i class="el-icon-video-camera" style="font-size:25px;color:#B9C9D6"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="文件名" min-width="200px">
          <template slot-scope="scope">
            <span v-if="!xiaStatus">
              <el-link @click="xiaYiJi(scope.row)">{{scope.row.name}}</el-link>
            </span>
            <span v-else>
              {{scope.row.name}}
            </span>
          </template>
        </el-table-column>
        <!--<el-table-column v-if="xiaStatus" prop="img" label="内容照片" min-width="200px">-->
          <!--<template   slot-scope="scope">-->
            <!--<img :src="imgUrl + scope.row.img"  min-width="70" height="70" />-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column prop="createdTime" label="创建时间" min-width="200px"></el-table-column>
        <el-table-column prop="id" label="操作" width="120px">
          <template slot-scope="scope">
            <span v-if="!xiaStatus">
              <!--<el-link @click="updateType(scope.row.id)">修改</el-link>-->
            <i class="el-icon-edit" @click="updateType(scope.row.id)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;
              <!--<el-link @click="deleteType(scope.row.id)">删除</el-link>-->
            <i class="el-icon-delete" @click="deleteType(scope.row.id)" style="font-size: 16px;color: #666;cursor: pointer"></i>
              <!--</el-button>-->
            </span>
            <span v-else>
              <el-link @click="yiDong(scope.row.id)">移动到</el-link>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="typeList.rows"
                   :current-page="typeList.page"
                   layout="prev, pager, next, jumper"
                   :total="typeList.total">
    </el-pagination>
    <!--添加视频分类弹窗-->
    <el-dialog title="视频分类管理" :visible.sync="videoTypeDialog" :show-close="false" width="50%">
      <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click.stop="cancelModal"><i
        class="el-dialog__close el-icon el-icon-close"></i></button>
      <el-form :model="videoType"  :rules="rules" ref="userForm" style="margin:0px auto;width: 90%">
        <el-form-item label="分类名称" label-width="80px" prop="name">
          <el-input v-model="videoType.name"type="text" ></el-input>
        </el-form-item>
        <el-form-item label="背景图片" label-width="80px" >
          <el-upload
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :http-request="uploadLecturerPhoto"
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
            :limit="1"
            :file-list="fileList"
            list-type="picture-card">
            <i class="el-icon-plus"></i>
            <!--<el-dialog :visible.sync="dialogVisible">-->
            <!--<img width="100%" :src="imgUrl" alt="">-->
            <!--</el-dialog>-->
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="back_reset">{{'取消'}}</el-button>
        <el-button v-if="loading" type="primary" :loading="true">保存中</el-button>
        <el-button v-else type="primary" @click="submitForm('userForm')">{{'保存'}}</el-button>
      </div>
    </el-dialog>
    <!--移动弹窗-->
    <el-dialog :visible.sync="allTypeDialog" :show-close="false" width="40%">
      <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click.stop="cancelModal1"><i
        class="el-dialog__close el-icon el-icon-close"></i></button>
      <el-table :data="allTypeList" highlight-current-row
                @current-change="handleCurrentChange1" height="260" >
        <el-table-column prop="name" label="文件名" min-width="200px"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel1" class="back_reset">{{'取消'}}</el-button>
        <el-button type="primary" @click="yiDongDao">{{'确定'}}</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import courseware from '@/api/courseware'
import video from '@/api/video'
import axios from 'axios'
import store from '../../store/index'
export default {
  name: 'Classify',
  data () {
    return {
      imgUrl: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/',
      value: true,
      xiaStatus: false,
      photoParam: '',
      rowId: null,
      rowName: null,
      courseId: null,
      currentRowId: null,
      fileList: [],
      allTypeList:[],
      loading: false,
      lawyerId: null,
      videoTypeDialog: false,
      allTypeDialog: false,
      typeList: {
        page: 1,
        rows: 15,
        total: 0,
        list: []
      },
      searchVo: {
        name: '',
        page: 1,
        rows: 15
      },
     videoType:{
       id: null,
       name: null,
       image: null
     },
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    reload () {
      courseware.findType(this.searchVo).then(res => {
        if (res.data.code === 0){
          this.typeList = res.data.data
        }
      })
    },
    handleCurrentChange1(val) {
      this.currentRowId = val.id
    },
    search () {
      this.searchVo.page = 1
      courseware.findType(this.searchVo).then(res => {
        this.$message.info(res.data.message)
        if (res.data.code === 0){
          this.typeList = res.data.data
        }
      })
    },
    yiDong (courseId) {
      this.courseId = courseId
      // console.log(courseId)
      this.allTypeDialog = true
      courseware.findAllType({name: ''}).then(res => {
        if (res.data.code === 0){
          this.allTypeList = res.data.data
        }
      })
    },
    yiDongDao () {
      let obj = {
        id: this.courseId,
        videotypeid: this.currentRowId
      }
      courseware.save(obj).then(res => {
        this.$message.info(res.data.message)
        if (res.data.code===0){
          this.allTypeDialog = false
          this.searchVo.page = 1
          let obj = {
            id: this.rowId,
            name: this.rowName
          }
          this.xiaYiJi(obj)
        }
      })
    },
    addType () {
      this.fileList = []
     this.videoType = {}
     this.videoTypeDialog = true
    },
    // 关闭弹窗
    cancel () {
      this.videoTypeDialog = false
      this.videoType = {}
    },
    cancel1 () {
      this.allTypeDialog = false
    },
    cancelModal () {
      this.videoTypeDialog = false
      this.videoType = {}
    },
    cancelModal1 () {
      this.allTypeDialog = false
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.searchVo.page = val
      if (!this.xiaStatus){
        this.reload()
      } else {
        let obj = {
          id: this.rowId,
          name: this.rowName
        }
        this.xiaYiJi(obj)
      }
    },
    // 保存视频分类
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          courseware.updateType(this.videoType).then(res => {
            this.loading = false
            this.$message.info(res.data.message)
            this.cancel()
            this.reload()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 删除
    deleteType (id) {
      this.$confirm('确定删除此视频分类吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        courseware.dels({id: id}).then(res => {
          this.$message.info(res.data.message)
          if (res.data.code===0){
            this.reload()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 修改
    updateType (id) {
      courseware.loadType({id:id}).then(res => {
        if (res.data.code === 0){
          this.videoTypeDialog = true
          this.videoType = res.data.data
          if (this.videoType.image !== null && this.videoType.image !== ''){
            this.fileList = []
            let upLoadImg = {
              url: this.imgUrl + this.videoType.image
            }
            this.fileList.push(upLoadImg)
          }
        }
      })
    },
    // 下一级
    xiaYiJi (row) {
      this.rowId = row.id
      this.rowName = row.name
      this.xiaStatus = true
      this.typeList = {
        page: 1,
        rows: 15,
        total: 0,
        list: []
      }
        courseware.find({page: this.searchVo.page, limit: 15, status: '1',videotypeid: row.id }).then(res => {
          // console.log(res.data.data)
          res.data.data.list.forEach(item => {
            let obj = {
              id: item.id,
              videoTypeId: item.videotypeid,
              name: item.title,
              createdTime: item.createdTime,
              img: item.img
            }
            this.typeList.list.push(obj)
          })
          this.typeList.page = res.data.data.page
          this.typeList.rows = res.data.data.rows
          this.typeList.total = res.data.data.total
        })
    },
    backTo () {
      this.xiaStatus = false// 返回上一层
      this.searchVo.page = 1
      this.typeList = {
        page: 1,
        rows: 15,
        total: 0,
        list: []
      }
      this.reload()
    },
    // 上传标题图片
    beforeUpload(file) {
      //重新写一个表单上传的方法
      this.photoParam = new FormData();
      this.photoParam.append('file', file, file.name)
      // return false;
    },
    handleRemove(file, fileList) {
      this.videoType.image = ''
    },
    uploadLecturerPhoto () {
      video.uploadPhoto(this.photoParam).then(res => {
        // console.log(res.data)
        if (res.data.code===0){
          this.$message.success('图片保存成功')
          let photoUrl = res.data.data
          photoUrl = photoUrl.replace(/\\/g,'/')
          // console.log(photoUrl)
          this.fileList = []
          let upLoadImg = {
            url: this.imgUrl + photoUrl
          }
          this.fileList.push(upLoadImg)
          this.videoType.image = photoUrl
        }else {
          this.$message.error('图片保存失败')
        }
      })
    }
  },
  created () {
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/video/Classify.vue